export const InputTypes = {
  INPUT: 'input',
  SELECT: 'select',
  INPUT_COUNTRY_CODE: 'input_country_code',
};